import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=5219efa4&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5219efa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5219efa4",
  null
  
)

export default component.exports